import { render } from "./MarketDominance.vue?vue&type=template&id=f3f8cf4c"
import script from "./MarketDominance.vue?vue&type=script&lang=js"
export * from "./MarketDominance.vue?vue&type=script&lang=js"

import "./MarketDominance.vue?vue&type=style&index=0&id=f3f8cf4c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__